// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"breadcrumbs_breadcrumbs__hJZ9a","breadcrumbs__slash-icon":"breadcrumbs_breadcrumbs__slash-icon__s4EDL"};